import UsersManager from "../managers/UsersManager";

export default class EndPoints {

    static readonly HOST = "http://localhost";
    static readonly SOCKET_HOST = EndPoints.HOST;
    static PRODUCTION_BASE_URL = `https://coinchester.herokuapp.com`
    static DEVELOPMENT_BASE_URL = `http://localhost:8080`;
    static BASE_URL = EndPoints.PRODUCTION_BASE_URL;
    static readonly INIT = `${EndPoints.BASE_URL}/init`;
    static readonly LOGIN = `${EndPoints.BASE_URL}/users/login`;
    static readonly LOGOUT = `${EndPoints.BASE_URL}/users/logout`;
    static readonly SIGN_UP = `${EndPoints.BASE_URL}/users/new`;
    static readonly PASSWORD_RECOVERY = `${EndPoints.BASE_URL}/users/forgotpwd`;
    static readonly MY_DATA = `${EndPoints.BASE_URL}/users/me`;
    static readonly NEW_GAME = `${EndPoints.BASE_URL}/games/new`;
    static readonly RESET_USER_DATA = `${EndPoints.BASE_URL}/users/reset`;
    static readonly FREE_BTC_INIT = `${EndPoints.BASE_URL}/free_btc/init`;
    static readonly GAMES = `${EndPoints.BASE_URL}/games/bets`;
    static readonly GET_NEW_FUNDING_ADDRESS = `${EndPoints.BASE_URL}/new_funding_address`;
    static readonly GET_TRANSACTION_FEE = `${EndPoints.BASE_URL}/transaction_fee`;
    static readonly WITHDRAW_BITCOINS = `${EndPoints.BASE_URL}/withdraw`;
    static readonly UPDATE_WITHDRAWAL_ADDRESS = `${EndPoints.BASE_URL}/updates/withdrawal_address`;
    static readonly UPDATE_PASSWORD = `${EndPoints.BASE_URL}/updates/password`;
    static readonly UPDATE_EMAIL_ADDRESS = `${EndPoints.BASE_URL}/updates/email`;
    static readonly UPDATE_USERNAME = `${EndPoints.BASE_URL}/updates/username`;
    static readonly UPDATE_2FA = `${EndPoints.BASE_URL}/updates/2fa`;
    static readonly FETCH_MY_TRANSACTIONS = `${EndPoints.BASE_URL}/transactions`;
    static readonly FETCH_PEOPLE_I_REFERRED = `${EndPoints.BASE_URL}/referrals`;
    static readonly CLOSE_ACCOUNT = `${EndPoints.BASE_URL}/close_account`;

    static getGames(gameType: number): string {
        return EndPoints.BASE_URL + "/games?gameType=" + gameType
    }

    static getMyGamesRoute(gameType: number): string {
        let loggedInUser = JSON.parse(UsersManager.getLoggedInUser() as string);
        return EndPoints.BASE_URL + "/users/" + loggedInUser["id"] + "/games/?gameType=" + gameType;
    }

}